@if (tableBids) {
  <table #biddingHistoryTable mat-table [dataSource]="tableBids" matSort class="w-100 bidding-history table-stack-sm">
    <ng-container matColumnDef="bidder">
      <th mat-header-cell *matHeaderCellDef > Bidder </th>
      <td mat-cell *matCellDef="let auctionBid"> {{auctionBid.partialUserName}} </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef > Status </th>
      <td mat-cell *matCellDef="let auctionBid"> {{auctionBid.displayRank}} </td>
    </ng-container>
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef > Bid Amount </th>
      <td mat-cell *matCellDef="let auctionBid"> {{auctionBid.currentDisplayBid | currency : 'USD' : 'symbol' : '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="time">
      <th mat-header-cell *matHeaderCellDef class="stack-last"> Bid Time </th>
      <td mat-cell *matCellDef="let auctionBid" class="stack-last" data-label="Bid Time"> {{auctionBid.bidDateTime | date:'medium' }} </td>
    </ng-container>
    @if (tableAuctionType==1) {
      <ng-container matColumnDef='autobid' >
        <th mat-header-cell *matHeaderCellDef><span class="flex-row items-center">Proxy Bid <mat-icon class="ml-2" matTooltip="A proxy bid is an automatic bidding feature where our system bids for you up to a maximum bid amount you enter. This feature is available for bids above the reserve amount.">info</mat-icon></span> </th>
        <td mat-cell *matCellDef="let auctionBid"> @if(auctionBid.autoBid) {<mat-icon class="green-color">check</mat-icon>}</td>
      </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let auctionBid; columns: displayedColumns;">
    </tr>
  </table>
}
